// exceljs et file-saver ne sont chargés qu'au moment d'un export (import dynamique dans
// exportTimesheetExcel). En import statique, exceljs partait dans le bundle principal et était
// téléchargé par tout le monde à chaque ouverture de l'appli, alors qu'il ne sert qu'ici.
import { holidaysSet } from './calendar';
import { buildCategories } from './categories';
import { writeHeader } from './header';
import { buildColumns, ROW } from './layout';
import { shadeAndBorder, writeCategoryRows, writeTotalRow } from './rows';

/**
 * Génère et télécharge la feuille de temps annuelle au format du modèle Uptime.
 * @param {object} p
 * @param {number} p.year
 * @param {string} p.personName
 * @param {Array}  p.timesheets  [{ date:'YYYY-MM-DD', brique_id, heures }]
 * @param {Array}  p.projets      st.projets
 */
export async function exportTimesheetExcel({ year, personName, timesheets, projets }) {
  const [{ default: ExcelJS }, { saveAs }] = await Promise.all([
    import('exceljs'),
    import('file-saver'),
  ]);
  const categories = buildCategories({ year, timesheets, projets });
  const grid = { year, personName, feries: holidaysSet(year), ...buildColumns(year) };

  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet(`Feuille ${year}`, {
    views: [{ state: 'frozen', xSplit: 2, ySplit: 3 }],
  });
  ws.getColumn(1).width = 26;
  ws.getColumn(2).width = 8;
  for (const mo of grid.months) {
    ws.getColumn(mo.gutter).width = 5;
    for (let c = mo.firstDay; c <= mo.lastDay; c++) ws.getColumn(c).width = 3.4;
  }
  writeHeader(ws, grid);
  writeTotalRow(ws, grid, categories.cats);
  const lastRow = writeCategoryRows(ws, grid, categories);
  shadeAndBorder(ws, grid, lastRow);
  ws.getRow(ROW.TITLE).height = 20;

  const buf = await wb.xlsx.writeBuffer();
  const safeName = personName.replace(/[^\p{L}\p{N} _-]/gu, '').trim() || 'collaborateur';
  saveAs(
    new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
    `Feuille de temps ${year} - ${safeName}.xlsx`,
  );
}
